
import { createTheme } from "@mui/material/styles";


const themeOptions = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#18B8FE',
    },
    secondary: {
      main: '#f50057',
    },
  },
});

export default themeOptions;